import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import useOnMount from 'hooks/useOnMount';
import useQuery from 'hooks/useQuery';
import { PodcastSubscription } from 'redux/middleware/api/podcast-service';
import { podcastSubscriptionsSelector } from 'redux/modules/entities';
import { pushModal } from 'redux/modules/modal';

const createPodcastSubscriptionSelector = (id: number) =>
  createSelector([podcastSubscriptionsSelector], (subs):
    | PodcastSubscription
    | undefined => {
    if (!subs || !id) {
      return undefined;
    }

    return subs.get(String(id))?.toJS();
  });

export default function useOpenEditAutomationModalFromURL() {
  const { subscriptionId } = useQuery();

  const dispatch = useDispatch();

  const podcastSubscriptionSelector = useMemo(
    () => createPodcastSubscriptionSelector(Number(subscriptionId)),
    [subscriptionId],
  );

  const subscription = useSelector(podcastSubscriptionSelector);

  useOnMount(() => {
    if (subscriptionId && subscription) {
      dispatch(
        pushModal({
          name: 'EditAutomationModal',
          params: {
            subscriptionId: Number(subscriptionId),
          },
        }),
      );
    }
  });
}
